import AbstractTrackingService from '@ve/services/analytics/yandexAnalytics/abstractTrackingService';
import {
    LEAD_BANNER_GOAL,
    LeadBannerFormStartParams,
    LeadBannerFormSubmitParams,
    LeadBannerImpressionParams,
    LeadBannerSheetOpenParams,
} from './types';

export default class LeadBannerTrackingService extends AbstractTrackingService {
    private static _instance: LeadBannerTrackingService;

    constructor() {
        super();
        if (LeadBannerTrackingService._instance) {
            return LeadBannerTrackingService._instance;
        }
        LeadBannerTrackingService._instance = this;
    }

    static getInstance(): LeadBannerTrackingService {
        if (!LeadBannerTrackingService._instance) {
            LeadBannerTrackingService._instance = new LeadBannerTrackingService();
        }
        return LeadBannerTrackingService._instance;
    }

    impression(params: LeadBannerImpressionParams): void {
        this.setTrackingGoal(LEAD_BANNER_GOAL.IMPRESSION, 'other', params);
    }

    sheetOpen(params: LeadBannerSheetOpenParams): void {
        this.setTrackingGoal(LEAD_BANNER_GOAL.SHEET_OPEN, 'other', params);
    }

    formStart(params: LeadBannerFormStartParams): void {
        this.setTrackingGoal(LEAD_BANNER_GOAL.FORM_START, 'other', params);
    }

    formSubmit(params: LeadBannerFormSubmitParams): void {
        this.setTrackingGoal(LEAD_BANNER_GOAL.FORM_SUBMIT, 'other', params);
    }
}
